import React from 'react';
import { useSmartFeedback } from '../contexts/SmartFeedbackContext';
import { FeedbackModal } from './ToxicDetector/FeedbackModal';
export function GlobalModals() {
  const {
    isOpen,
    milestone,
    closeFeedback
  } = useSmartFeedback();
  return <FeedbackModal isOpen={isOpen} milestone={milestone} onClose={closeFeedback} data-id="element-1105" />;
}